import styled from 'styled-components';
import { RegularButton } from 'pg-ui-library';

export const Settings = styled(RegularButton)`
  padding: 8px;
`;

export const SettingsIcon = styled.img`
  height: 19px;
  width: auto;
`;

export const Container = styled.div``;

export const CheckboxContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border: 2px solid #4948ac;
  border-radius: 5px;
  position: relative;
  z-index: 1;
  background-color: white;
  padding: 10px;
  min-width: 300px;
  font-family: Biotif;
  font-size: 14px;
`;

export const RelativeContainer = styled.div`
  position: relative;
  width: 0;
  height: 0;
`;

export const AbsoluteContainer = styled.div`
  position: absolute;
  top: -5px;
  right: -50px;
`;
